import { configureStore } from '@reduxjs/toolkit'
import counterReducer from '../components/creationArea/counterSlice'

export const store = configureStore({
  reducer: {
    counter: counterReducer,
  },
})